const TUTOR_VOICE = {
    "Abraham_Lincoln": "ksCO8IQ0Hg4ZbGCzLAcT",
    "Cleopatra": "PTLF16GTrTlDV4xVffeX",
    "Albert_Einstein": "binpfdMZU95eVENr8lvZ",
    "Mahatma_Gandhi": "MITEIPJGUNUp5lBuaqHV",
    "King_Tut": "eKvgEjw0vD7FT6s8k3um",
    "amelia": "pWwlgKrLH056h3qqtWTS",
    "LISA": "LMtSPQoDkjHWxO7FYr4j"
};

const TUTOR_CAPITALIZE = {
    "ABRAHAM_LINCOLN": "Abraham_Lincoln",
    "CLEOPATRA": "Cleopatra",
    "EINSTEIN": "Albert_Einstein",
    "GANDHI": "Mahatma_Gandhi",
    "KINT_TUT": "King_Tut",
    "AMELIA_EARHART": "amelia",
    "LISA": "LISA"
};
export const UNITY_MODULE = 'presenter_mode';
export const COMMAND_ROUTE = 'c';
export const USER_ROUTE = 'u';
export const VIEWBOARD_SYNC = 'b';


export const UnityObjectName = 'ReactUnityBridge';
export const MethodName = 'ReceiveMessage';
export const AudioMethodName = 'ReceiveAudioMessage';
export const StartingMethodName = 'ReceiveStartingMessage';

export { TUTOR_VOICE, TUTOR_CAPITALIZE }